import { StrictMode } from "react";
import ReactDOM from "react-dom";
import AuthProvider from "@poseidon/ui/components/AuthContext";
import { LocalizationProvider } from "@mui/lab";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { BrowserRouter } from "react-router-dom";
import AdminApp from "./app/App";

ReactDOM.render(
  <StrictMode>
    <AuthProvider profileCollection="dealers" requiresClaim="dealer">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <BrowserRouter>
          <AdminApp />
        </BrowserRouter>
      </LocalizationProvider>
    </AuthProvider>
  </StrictMode>,
  document.getElementById("root")
);
